import styled, { css } from 'styled-components'

import Typography from '../Typography'

export const DynamicTooltipTypographyContainer = styled.p`
  display: inline-block;

  overflow: hidden;
  margin: 0;
  min-width: 0;
`

export const DynamicTypography = styled(Typography)<{ $lineClamp: number; $maxWidth?: number }>`
  display: inline;

  height: inherit;
  width: inherit;
  max-height: inherit;
  max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}ch` : 'inherit')};

  text-align: inherit;
  font-family: inherit;
  letter-spacing: inherit;
  font-size: ${({ size }) => (size ? undefined : 'inherit')};
  line-height: ${({ lineHeight }) => (lineHeight ? undefined : 'inherit')};
  font-weight: ${({ weight }) => (weight ? undefined : 'inherit')};
  color: ${({ color }) => (color ? undefined : 'inherit')};
  text-decoration: ${({ decoration }) => (decoration ? undefined : 'inherit')};
  text-transform: ${({ textTransform }) => (textTransform ? undefined : 'inherit')};

  .dynamic-typography-wrapper {
    all: inherit;

    display: block;
    width: 100%;
    max-width: ${({ $maxWidth }) => ($maxWidth ? `${$maxWidth}ch` : '100%')};

    overflow: hidden;
    text-overflow: ellipsis;

    ${({ $lineClamp }) =>
      $lineClamp &&
      $lineClamp !== 1 &&
      css`
        display: -webkit-box;
        -webkit-line-clamp: ${$lineClamp};
        -webkit-box-orient: vertical;
      `}

    ${({ $lineClamp }) =>
      $lineClamp == 1 &&
      css`
        white-space: nowrap;
      `}
  }
`
